import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {sendInvoice} from '../../../../redux/cash/cashActions';
import {TState} from '../../../../redux/store.type';
import {UseSendProps} from '../../../../hooks/sendHooks.types';

export const useInvoiceSend = ({whatsappData, emailData, smsData, show}: UseSendProps) => {
    const invoicePostFields = useSelector((state: TState) => state.cash.invoicePostFields);

    const handleSend = useCallback(async (type: string, trialRecipients?: string[]) => {
        try {
            await sendInvoice({
                ...(type === 'email' ? emailData : type === 'sms' ? smsData : whatsappData),
                postFields: invoicePostFields,
                type,
                ...(trialRecipients ? {trialRecipients} : {})
            });
            return true;

        } catch (error) {
            console.error('Failed to send invoice:', error);
            show.close();
            return false;
        }
    }, [whatsappData, emailData, smsData, invoicePostFields, show]);

    return {handleSend};
};

